export default "__VITE_ASSET__b065846e__"